export enum IPlannerRoomNames {
    Kitchen = "kitchen",
    LivingRoom = "living room",
    LivingRoomWithKitchenette = "living room with kitchenette",
    DiningRoom = "dining room",
    Bedroom = "bedroom",
    Bathroom = "bathroom",
    Garden = "garden",
    Balcony = "balcony",
    Terrace = "terrace"
}
export enum IPlannerRoomNames {
    Kitchen = "kitchen",
    LivingRoom = "living room",
    LivingRoomWithKitchenette = "living room with kitchenette",
    DiningRoom = "dining room",
    Bedroom = "bedroom",
    Bathroom = "bathroom",
    Garden = "garden",
    Balcony = "balcony",
    Terrace = "terrace"
}
